import { Col, Menu, Row, Space } from "antd";
import { BarsOutlined, BarChartOutlined, TeamOutlined, CreditCardOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useOutletContext, useParams } from "react-router";
import { getProjectService } from "../../backend";
import { IProjectDetails } from "../../types";

export default function ProjectSettingsRoot() {
    const navigate = useNavigate();
    const location = useLocation();
    const { projectId } = useParams();
    const { projectDetails } = useOutletContext<{ projectDetails: IProjectDetails }>();
    const [activeTab, setActiveTab] = useState("general");

    useEffect(() => {
        setActiveTab(location.pathname.split("/")[4] || "general");

        const loadData = async () => {
            await getProjectService().getUsers(projectId!);
        }
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    return (
        <Row gutter={24}>
            <Col span={6}>
                <Menu
                    mode="inline"
                    className="ant-card-bordered"
                    selectedKeys={[activeTab]}
                    onSelect={(item) => {
                        navigate(item.key);
                        setActiveTab(item.key);
                    }}
                    items={[
                        {
                            key: "general",
                            label: <Space>
                                <BarsOutlined />
                                General
                            </Space>
                        },
                        {
                            key: "usage",
                            label: <Space>
                                <BarChartOutlined />
                                Plan usage
                            </Space>
                        },
                        {
                            key: "members",
                            label: <Space>
                                <TeamOutlined />
                                Members
                            </Space>
                        }, {
                            key: "billing",
                            label: <Space>
                                <CreditCardOutlined />
                                Billing
                            </Space>
                        }
                    ]}
                />
            </Col>
            <Col span={18}>
                <Outlet context={{ projectDetails }} />
            </Col>
        </Row >
    )
}